import { useCallback } from 'react';
import { SixDoorContent } from 'shared/components/SixDoorContent';
import { useAppDispatch } from 'shared/hooks';
import { setModalContent } from 'shared/slices';
import { TDoor } from 'shared/types/doors';

export const SixDoorContentContainer: React.FC<Omit<TDoor, 'onClickBtn'>> = props => {
  const dispatch = useAppDispatch();

  const handleClickBtn = useCallback(() => {
    dispatch(setModalContent({ type: 'quiz' }));
  }, [dispatch]);

  return <SixDoorContent onClickBtn={handleClickBtn} {...props} />;
};
